import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from '@angular/core';
import { AppState } from '../../../app.service';
var DeliveryFeeComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function DeliveryFeeComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    DeliveryFeeComponent.prototype.ngOnInit = function () {
    };
    return DeliveryFeeComponent;
}());
export { DeliveryFeeComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/delivery-fee/delivery-fee.component.ts
// module id = null
// module chunks = 